import request from '@/config/axios'

// AI 提示词 VO
export interface AiPromptVO {
  id: number
  promptCode: string
  promptName: string
  promptContent: string
  variables?: string
  version?: number
  status: number
  remark?: string
  createTime?: Date
}

// AI 提示词 API
export const PromptApi = {
  // 获得提示词分页
  getPromptPage: async (params: any) => {
    return await request.get({ url: '/ai/prompt/page', params })
  },

  // 获得提示词详情
  getPrompt: async (id: number) => {
    return await request.get({ url: '/ai/prompt/get?id=' + id })
  },

  // 创建提示词
  createPrompt: async (data: AiPromptVO) => {
    return await request.post({ url: '/ai/prompt/create', data })
  },

  // 更新提示词
  updatePrompt: async (data: AiPromptVO) => {
    return await request.put({ url: '/ai/prompt/update', data })
  },

  // 删除提示词
  deletePrompt: async (id: number) => {
    return await request.delete({ url: '/ai/prompt/delete?id=' + id })
  },

  // 获得提示词下拉列表
  getPromptSimpleList: async () => {
    return await request.get({ url: '/ai/prompt/simple-list' })
  }
}
